var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pm-simple-component-layout',{attrs:{"toolbar-back":_vm.toolbarBack}},[_c('template',{slot:"title"},[_vm._v("\n        Privacy Policy\n    ")]),_c('pm-privacy-content')],2)}
var staticRenderFns = []

export { render, staticRenderFns }